import { setDisplayMessage, setDisplayMessageType } from "../store/XSifterAppReducer";
import { UNAUTHORIZED } from "../XSifterAppConstants";

const GENERIC_ERROR_MESSAGE = "an unknown error occurred";

/**
 * Shows an error message to the user for a failed API call.
 * 401s are skipped: the auth interceptor has already logged the user out and set the
 * "session timed out" message, which this would otherwise overwrite.
 */
export const showApiError = (dispatch: (action: any) => any, error: any, fallbackMessage: string) => {
    if (error?.error?.statusCode === UNAUTHORIZED) {
        return;
    }

    const reason: string | undefined = error?.error?.errorMessage;
    const message = reason && reason !== GENERIC_ERROR_MESSAGE
        ? `${fallbackMessage}: ${reason}`
        : fallbackMessage;

    dispatch(setDisplayMessage(message));
    dispatch(setDisplayMessageType("error"));
};
